import { compose, head, map, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { Reservation } from '@mews-commander/data-access';
import { getOrderItemsByServiceOrderIds } from '@mews-commander/legacy-entities/src/ducks/orderItems';
import { getDefaultProductOrderItemMapByServiceOrderId } from '@mews-commander/legacy-entities/src/selectors/orderItems';
import {
    getCheckedReservationIds,
    getServiceCheckedReservationsIds,
    getServiceNonCancelledCheckedReservations,
} from '../reservationModuleState';

export const getServiceReservationsStartUtc = createSelector(
    getServiceNonCancelledCheckedReservations,
    compose(head, map<Reservation, 'startUtc'>('startUtc'), orderBy<Reservation>('startUtc', ['asc']))
);

export const getServiceReservationsEndUtc = createSelector(
    getServiceNonCancelledCheckedReservations,
    compose(head, map<Reservation, 'endUtc'>('endUtc'), orderBy<Reservation>('endUtc', ['desc']))
);

export const getSelectedReservationsOrderItems = composeProps(
    getOrderItemsByServiceOrderIds,
    createPropsExtender('serviceOrderIds', getCheckedReservationIds)
);

export const getServiceSelectedReservationsDefaultProductOrders = createSelector(
    getDefaultProductOrderItemMapByServiceOrderId,
    getServiceCheckedReservationsIds,
    (defaultProductOrdersMap, reservationIds) =>
        reservationIds.flatMap((reservationId) => defaultProductOrdersMap[reservationId] ?? [])
);
export const getServiceSelectedReservationsOrderItems = composeProps(
    getOrderItemsByServiceOrderIds,
    createPropsExtender('serviceOrderIds', getServiceCheckedReservationsIds)
);
